import { render } from "./AttendancePreferenceSettings.vue?vue&type=template&id=82514c88"
import script from "./AttendancePreferenceSettings.vue?vue&type=script&lang=js"
export * from "./AttendancePreferenceSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__